import i18n from '@/plugins/i18n'

const index = 'category.index'

export default [
    {
        path: '/' + i18n.t('routes.category.index'),
        name: index,
        component: () =>
            import(
                /* webpackChunkName: "categories" */ '@/views/categories/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.category.breadcrumb.index'),
                    to: { name: index },
                    disable: true,
                },
            ],
            showName: 'Categorias',
        },
    },
]
